import React from 'react'
import { ControlledSwitch } from 'transfix-form/components'
import { Box, Typography, capitalize } from 'transfix-ui/core'
import { TRANSFIX_FLAGS_POLICY_TYPES } from '../../constants'
import { useTransfixFlagEditModalFormContext } from './useTransfixFlagEditModalForm'

interface IFlagSwitch {
  name: string
  title: string
}

const FlagSwitch = ({ name, title }: IFlagSwitch) => {
  const { control, watch } = useTransfixFlagEditModalFormContext()
  const label = watch(name) ? 'Yes' : 'No'
  const dataTest = `switch-is${capitalize(name)}`
  return (
    <Box display='flex' alignItems='center' mb={2} justifyContent='space-between'>
      <Typography variant='subtitle1'>Transfix {title}</Typography>
      <ControlledSwitch
        name={name}
        control={control}
        SwitchProps={{
          label,
          dataTest,
        }}
      />
    </Box>
  )
}

interface ITransfixFlagEditModalForm {
  isType: string
}

export const TransfixFlagEditModalForm = ({ isType }: ITransfixFlagEditModalForm) => {
  const {
    TRANSFIX_AS_HOLDER,
    TRANSFIX_LISTED_AS_ADDITIONAL_INSURED,
    TRANSFIX_LISTED_AS_PAYEE,
  } = TRANSFIX_FLAGS_POLICY_TYPES

  const showAsAdditionalInsured = TRANSFIX_LISTED_AS_ADDITIONAL_INSURED.includes(isType)
  const showAsHolder = TRANSFIX_AS_HOLDER.includes(isType)
  const showAsLossPayee = TRANSFIX_LISTED_AS_PAYEE.includes(isType)

  return (
    <form data-test='TransfixFlagEditModalForm'>
      {showAsHolder && <FlagSwitch name='transfixHolder' title='as a Holder' />}
      {showAsAdditionalInsured && (
        <FlagSwitch name='transfixAdditionalInsured' title='Listed as Additional Insured' />
      )}
      {showAsLossPayee && <FlagSwitch name='transfixLossPayee' title='Listed as Loss Payee' />}
    </form>
  )
}
